import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import BtnLight from "../../../../../../common/element/Buttons/btnLight";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary";
import Dialog from "../../../../../../common/element/Dialog/Dialog";
import { notify } from "react-notify-toast";
import WorkersList from "./WorkersList";
import { GetAllIndividualListForWorkerInvites } from "../../../../../../actions/admin-provider/GetAllIndividualListForWorkerInvites";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../../../../../common/snippet/Debouncing";
import { InviteWorker } from "../../../../../../actions/admin-worker/InviteWorker";
import ClientInput from "../../../../../../common/element/Input/clientInput";
import { GetProviderWorkersInvite } from "../../../../../../actions/admin-provider/GetSpecificContractorWorkerInvites";
import ReactPaginate from "react-paginate";
import Segment from "../../../../../../common/element/Segment";
import Validations from "../../../../../../common/404/Validations";
import { GetIndividualByEmail } from "../../../../../../actions/public/GetIndividualByEmail";
import Dropdown from "../../../../../../common/element/Dropdown";
import { CSVLink } from "react-csv";
import Button from "../../../../../../common/element/Buttons";
import { inviteWorkerCsvView } from "../../../../../../actions/admin-provider/inviteContractorWorkerCsvView";
import MultiSelect from "@mui/material/Select";
import Td from "../../../../../../common/element/Table/Td";
import TBody from "../../../../../../common/element/Table/TBody";
import Th from "../../../../../../common/element/Table/Th";
import OutlinedInput from "@mui/material/OutlinedInput";
import Tr from "../../../../../../common/element/Table/Tr";
import Table from "../../../../../../common/element/Table";
import Scrollbar from "../../../../../../common/element/ScrollBar";
import THead from "../../../../../../common/element/Table/THead";
import Checkbox from "../../../../../../common/element/Checkbox";
import { reSetData } from "../../../../../../redux/classes/AdminContractor/inviteContractorWorkerCsvViewSlice";
import { InviteWorkerFromCsvDetails } from "../../../../../../actions/admin-provider/InviteWorkerFromCsvDetails";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice";
import { useParams } from "react-router-dom";
import ListItemText from "@mui/material/ListItemText";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler";
import { Pagination } from "../../../../../../common/pagination";
import { GetAllClientsOfProviderList } from "../../../../../../actions/admin-provider/GetAllClientsOfContractorList";
import MenuItem from "@mui/material/MenuItem";
import Select from "../../../../../../common/element/Select";
import ViewAll from "./viewAll";
import { GetAllWorkersOfProvider } from "../../../../../../actions/admin-provider/clients/GetAllWorkersOfProvider";
import NonCompliantList from "./NonCompliant";
import CompliantList from "./Compliant";
import ScrollBar from "../../../../../../common/element/ScrollBar/ScrollBar";
import { decryptId } from "../../../../../../common/encryptDecrypt/encryptdecrypt";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentMethod from "./payment";
import PaymentMethodForCsv from "./payment/PaymentMethodForCsv";
import Tooltip from "../../../../../../common/element/Tooltip";
import * as actionType from "../../../../../../constant/actionType";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Workers = (props) => {
  const { SpecificProviderData } = useSelector((state) => state);
  const Allfunction = useSelector((state) => state?.allFunctions?.allFunction);
  const ipAddress = useSelector((state) => state?.ipAddress?.ip);
  const { id } = useParams();
  const orgId = decryptId(id);
  const dispatch = useDispatch();

  const exportCsvLinkRef = React.useRef(null);
  const [exportCsvRows, setExportCsvRows] = useState([]);
  const [isExportingWorkers, setIsExportingWorkers] = useState(false);

  const handleUnauthorizedAccess = useUnauthorizedHandler();
  useEffect(() => {
    // Set breadcrumbs when the component mounts
    dispatch(
      setBreadcrumbs([
        {
          label: "View All Provider",
          url: "/admin/provider/view-all-provider",
          home: "/admin/provider/dashboard",
        },
        {
          label: `${SpecificProviderData?.trading_name}`,
          url: `/admin/provider/view-all-provider/specific-provider/${encodeURIComponent(
            id
          )}`,
        },
        {
          label: "Workers",
          url: `/admin/provider/view-all-provider/specific-provider/${encodeURIComponent(
            id
          )}`,
        },
      ])
    );
  }, []);
  let current_user;
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  if (storedData !== null) {
    current_user = `${storedData?.userName?.first_name || ""} ${storedData?.userName?.last_name || ""
      }`;
  }

  const [stepForm, setStepForm] = useState(0);
  const [seatCount, setseatCount] = useState(0);
  const [assignedWorkers, setAssignedWorkers] = useState(0);
  const [isProvLicencePaid, setIsProvLicencePaid] = useState(false);
  const [provider_type_id, setProvider_type_id] = useState(null);
  const [dialogIsOpen, setIsOpen] = useState(false);
  const [singleSegmentValue, setSingleSegmentValue] = useState("workers");
  const [dialogAddOpen, setAddOpen] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState("")
  const [checkExistingWorker, setcheckExistingWorker] = useState(false);
  const [search, setSearch] = useState("");
  const [search2, setSearch2] = useState("");
  const [customOptions, setcustomOptions] = useState([]);
  const [inviteData, setinviteData] = useState([]);
  const [readOnly, setreadOnly] = useState(false);
  const [validateData, setvalidateData] = useState(false);
  const [dialogNextCsv, setDialogNextCsv] = useState(false);

  const exportWorkersCsvHeaders = [
    { label: "Worker name", key: "worker_name" },
    { label: "Email", key: "email" },
  ];

  const fetchWorkersForExport = async () => {
    if (!orgId) return [];

    const baseParams = {
      ...getAllinvitedData,
      page: 1,
      limit: 10000,
      search,
    };

    let params = { ...baseParams };

    if (singleSegmentValue === "workers") {
      delete params.statusType;
      delete params.function_assignment_id;
      params.provider_org_id = orgId;
    } else if (
      singleSegmentValue === "compliant" ||
      singleSegmentValue === "nonCompliant"
    ) {
      delete params.function_assignment_id;
      params.provider_org_id = orgId;
      params.statusType =
        singleSegmentValue === "compliant" ? "Compliant" : "NonCompliant";
    } else {
      // Invited segment uses a different endpoint, so don't export here.
      notify.show("Export is available for provider workers.", "warning", 3000);
      return [];
    }

    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/GetAllWorkersOfProvider`,
      params,
    });

    const rows = response?.data?.data?.rows || [];

    return rows.map((w) => {
      const first = w?.worker_individual?.first_name || w?.first_name || "";
      const last = w?.worker_individual?.last_name || w?.last_name || "";
      const worker_name = `${first} ${last}`.trim();
      const email = w?.worker_individual?.email || w?.email || "";

      return {
        worker_name: worker_name || "-",
        email: email || "-",
      };
    });
  };

  const handleExportAllWorkers = async (format = "csv") => {
    if (!orgId) return;
    setIsExportingWorkers(true);

    try {
      const exportRows = await fetchWorkersForExport();
      if (!exportRows?.length) {
        return;
      }

      if (format === "csv") {
        setExportCsvRows(exportRows);
        setTimeout(() => {
          exportCsvLinkRef?.current?.link?.click();
        }, 0);
        return;
      }

      if (format === "excel") {
        const headerRow = exportWorkersCsvHeaders.map((h) => h.label);
        const dataRows = exportRows.map((row) =>
          exportWorkersCsvHeaders.map((h) => row[h.key])
        );
        const aoa = [headerRow, ...dataRows];
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Workers");
        XLSX.writeFile(wb, `provider-workers-${orgId}.xlsx`);
        return;
      }

      if (format === "pdf") {
        const doc = new jsPDF("p");
        const tableColumn = exportWorkersCsvHeaders.map((h) => h.label);
        const tableRows = exportRows.map((row) =>
          exportWorkersCsvHeaders.map((h) => row[h.key])
        );
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 15,
          rowPageBreak: "avoid",
          styles: { fontSize: 10 },
          headStyles: { fillColor: "#E5F3FE", textColor: "#464A53" },
          bodyStyles: { textColor: "#000000" },
        });
        doc.save(`provider-workers-${orgId}.pdf`);
      }
    } catch (error) {
      notify.show("Failed to export workers.", "error", 3000);
      console.error("Export workers error:", error);
    } finally {
      setIsExportingWorkers(false);
    }
  };
  const [refetch, setrefetch] = useState(false);
  const [finalCsvData, setfinalCsvData] = useState([]);
  const [checkRequired, SetcheckRequired] = useState("");
  const [searchOptions, setsearchOptions] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [dialogOpenCSV, setCSV] = useState(false);
  const [allClient, setAllClient] = useState([]);
  const [updateCsvData, setUpdateCsvData] = useState(false);
  const [selectedClientType, setSelectedClientType] = useState("");
  const [personName, setPersonName] = React.useState([]);

  const [checkError, setCheckError] = React.useState(false);

  const [selectedOption, setSelectedOption] = useState("");

  const [errorvalidation, seterrorvalidation] = useState({
    email: "",
    fistName: "",
    lastName: "",
    workerClientsIds: "",
  });

  const [addWorkerData, setAddWorkerData] = useState({
    trading_name:
      SpecificProviderData?.trading_name /* provider trading name */,
    provider_org_id: orgId,
    current_user: current_user,
    provider_fa_id: SpecificProviderData?.provider_fa_id,
    workersInviteData: [
      {
        individual_id: "",
        email: "",
        first_name: "",
        last_name: "",
      },
    ],
    workerClientsIds: "",
  });

  let totalWorker = (addWorkerData?.workersInviteData?.length || 0);
  // Load your publishable key
  const stripePromise = loadStripe(
    "pk_test_51QnIiwCM2kq63G3G043lAdhh8imre5jnUiTsQqQhIfhsUZU87gAYscKgZXiXnjIABRsXHR69otQp8l23IEtTD8ft00IzGHMaWl"
  );

  const [errorValidation, setErrorValidation] = useState({
    email: "",
    fistName: "",
    lastName: "",
    workerClientsIds: "",
    providerNameError: "",
    clientNameError: "",
    // Initialize worker-specific errors
    ...addWorkerData?.workersInviteData?.reduce((acc, _, index) => {
      acc[`firstNameError_${index}`] = "";
      acc[`lastNameError_${index}`] = "";
      acc[`emailError_${index}`] = "";
      acc[`conserveTeamError_${index}`] = "";
      acc[`alreadyWorkerError_${index}`] = "";
      acc[`alreadyInvitedError_${index}`] = "";

      return acc;
    }, {}),
  });

  const [dialogUnsaveOpen, setUnsaveOpen] = useState(false);
  const openDialog = () => {
    setIsOpen(true);
    setinviteData([]);
    setcheckExistingWorker(false);
  };
  const onDialogClose = (e) => {
    setErrorValidation({
      email: "",
      fistName: "",
      lastName: "",
      workerClientsIds: "",
      providerNameError: "",
      clientNameError: "",
      ...addWorkerData?.workersInviteData?.reduce((acc, _, index) => {
        acc[`firstNameError_${index}`] = "";
        acc[`lastNameError_${index}`] = "";
        acc[`emailError_${index}`] = "";
        acc[`conserveTeamError_${index}`] = "";
        acc[`alreadyWorkerError_${index}`] = "";
        acc[`alreadyInvitedError_${index}`] = "";

        return acc;
      }, {}),
    });

    openUnsaveDialog() // empty data payment related
    seterrorvalidation({
      email: "",
      fistName: "",
      lastName: "",
      workerClientsIds: "",
    });
    setIsOpen(false);
    setCheckError(false);
    // props.getOnDialogClose(onDialogClose);
    setAddWorkerData({
      trading_name: "provider_trading static_data" /* provider trading name */,
      provider_fa_id: SpecificProviderData?.provider_fa_id,
      workersInviteData: [
        {
          individual_id: "",
          email: "",
          first_name: "",
          last_name: "",
        },
      ],
      workerClientsIds: "",
    });
    setPersonName([]);
  };

  // const openAddDialog = (step, checkInvite) => {
  //   let checkValidation = addWorkerData?.workersInviteData?.every(
  //     (item) => item.first_name && item.last_name && item.email
  //   );
  //   setCheckError(true);
  //   let validationCheck = true;

  //   const workerClientsIds = Validations({
  //     value: addWorkerData?.workerClientsIds?.[0],
  //     Validations: { required: true },
  //   });

  //   if (true) {
  //     if (!workerClientsIds.valid) {
  //       seterrorvalidation((prevalue) => {
  //         return {
  //           ...prevalue,
  //           ["workerClientsIds"]: workerClientsIds.error_msg,
  //         };
  //       });
  //     }

  //     if (workerClientsIds.valid) {
  //       validationCheck = true;
  //     } else {
  //       validationCheck = false;
  //     }
  //   } else {
  //     validationCheck = true;
  //   }

  //   if (validationCheck && checkValidation) {
  //     // if (inviteData.length === 0) {
  //     //   setvalidateData(true);
  //     // }
  //     // if (inviteData?.value) {
  //     //   setvalidateData(false);
  //     //   setcheckExistingWorker(true);
  //     // }

  //     if (!inviteData.is_conserve_team) {
  //       setStepForm(1);
  //       const updateObject = {
  //         ...addWorkerData,
  //         trading_name:
  //           "provider_trading static_data" /* provider trading name */,
  //         provider_org_id: orgId,
  //         current_user: current_user,
  //       };

  //       // dispatch(InviteWorker(updateObject))
  //       //   .then((response) => {
  //       //     if (response.success) {
  //       //       setAddOpen(true);
  //       //       setIsOpen(false);
  //       //       setinviteData([]);
  //       //       setrefetch(!refetch);
  //       //     }
  //       //     if (response.status == 409) {
  //       //       notify.show(response.message, "error");
  //       //     } else if (response.status === 401) {
  //       //       handleUnauthorizedAccess();
  //       //     }
  //       //   })
  //       //   .catch((error) => {});
  //     } else {
  //       notify.show("This worker is not invited", "error");
  //     }
  //   } else {
  //     const emailValidation = Validations({
  //       value: inviteData.email,
  //       Validations: { required: true, email: true },
  //     });
  //     if (inviteData.length === 0) {
  //       setvalidateData(true);
  //       SetcheckRequired(emailValidation.error_msg);
  //     } else {
  //       if (!emailValidation.valid) {
  //         setvalidateData(true);
  //         SetcheckRequired(emailValidation.error_msg);
  //       } else {
  //         setcheckExistingWorker(true);
  //       }
  //     }
  //   }
  // };
  const openAddDialog = (step, checkInvite) => {
    if (checkInvite) {
      let checkValidation = addWorkerData?.workersInviteData?.every(
        (item) => item.first_name && item.last_name && item.email
      );
      setCheckError(true);
      let validationCheck = true;

      const workerClientsIds = Validations({
        value: addWorkerData?.workerClientsIds?.[0],
        Validations: { required: true },
      });

      if (true) {
        if (!workerClientsIds.valid) {
          seterrorvalidation((prevalue) => {
            return {
              ...prevalue,
              ["workerClientsIds"]: workerClientsIds.error_msg,
            };
          });
        }

        if (workerClientsIds.valid) {
          validationCheck = true;
        } else {
          validationCheck = false;
        }
      } else {
        validationCheck = true;
      }

      if (validationCheck && checkValidation) {
        // if (inviteData.length === 0) {
        //   setvalidateData(true);
        // }
        // if (inviteData?.value) {
        //   setvalidateData(false);
        //   setcheckExistingWorker(true);
        // }
        if (!inviteData.is_conserve_team) {
          const updateObject = {
            ...addWorkerData,
            trading_name:
              SpecificProviderData?.trading_name /* provider trading name */,
            provider_org_id: orgId,
            current_user: current_user,
            client_trading_names: personName?.length > 0 ? personName.map(client => client?.label) : [],
          };
          dispatch(InviteWorker(updateObject, ipAddress))
            .then((response) => {
              if (response.success) {
                localStorage.setItem("workerInviteData", "");
                setAddOpen(true);
                setIsOpen(false);
                setinviteData([]);
                setrefetch(!refetch);
              }
              if (response.status == 409) {
                notify.show(response.message, "error");
              } else if (response.status === 401) {
                handleUnauthorizedAccess();
              }
            })
            .catch((error) => { });
        } else {
          notify.show("This worker is not invited", "error");
        }
      } else {
        const emailValidation = Validations({
          value: inviteData.email,
          Validations: { required: true, email: true },
        });
        if (inviteData.length === 0) {
          setvalidateData(true);
          SetcheckRequired(emailValidation.error_msg);
        } else {
          if (!emailValidation.valid) {
            setvalidateData(true);
            SetcheckRequired(emailValidation.error_msg);
          } else {
            setcheckExistingWorker(true);
          }
        }
      }
    } else {
      if (step == 0) {
        let checkValidation = addWorkerData?.workersInviteData?.every(
          (item) => item.first_name && item.last_name && item.email
        );
        setCheckError(true);
        let validationCheck = true;

        const workerClientsIds = Validations({
          value: addWorkerData?.workerClientsIds?.[0],
          Validations: { required: true },
        });

        if (true) {
          if (!workerClientsIds.valid) {
            seterrorvalidation((prevalue) => {
              return {
                ...prevalue,
                ["workerClientsIds"]: workerClientsIds.error_msg,
              };
            });
          }

          if (workerClientsIds.valid) {
            validationCheck = true;
          } else {
            validationCheck = false;
          }
        } else {
          validationCheck = true;
        }

        if (validationCheck && checkValidation) {
          if (!inviteData.is_conserve_team) {
            // If first selected client pays, skip payment flow and invite directly
            if (personName?.length > 0 && personName[0]?.is_client_pays === true) {
              const updateObject = {
                ...addWorkerData,
                trading_name:
                  SpecificProviderData?.trading_name /* provider trading name */,
                provider_org_id: orgId,
                current_user: current_user,
                client_trading_names: personName?.length > 0 ? personName.map((client) => client?.label) : [],
              };
              dispatch(InviteWorker(updateObject, ipAddress))
                .then((response) => {
                  if (response.success) {
                    localStorage.setItem("workerInviteData", "");
                    setAddOpen(true);
                    setIsOpen(false);
                    setinviteData([]);
                    setrefetch(!refetch);
                  }
                  if (response.status == 409) {
                    notify.show(response.message, "error");
                  } else if (response.status === 401) {
                    handleUnauthorizedAccess();
                  }
                })
                .catch((error) => { });
            } else {
              let data = { ...addWorkerData, clientData: personName };
              localStorage.setItem("workerInviteData", JSON.stringify(data));
              setStepForm(1);
            }
          } else {
            notify.show("This worker is not invited", "error");
          }
        } else {
          const emailValidation = Validations({
            value: inviteData.email,
            Validations: { required: true, email: true },
          });
          if (inviteData.length === 0) {
            setvalidateData(true);
            SetcheckRequired(emailValidation.error_msg);
          } else {
            if (!emailValidation.valid) {
              setvalidateData(true);
              SetcheckRequired(emailValidation.error_msg);
            } else {
              setcheckExistingWorker(true);
            }
          }
        }
      }
    }
  };
  const onAddDialogClose = (e) => {
    setAddOpen(false);
    onDialogClose();
    setrefetch(!refetch);
    // props.getOnDialogClose(onAddDialogClose);
  };

  const openUnsaveDialog = () => {
    setUnsaveOpen(true);
    setIsOpen(false);
    localStorage.setItem("workerInviteData", "");
    setStepForm(0);
    setIsOpen(false);
    setCheckError(false);
    // props.getOnDialogClose(onDialogClose);
    setAddWorkerData({
      trading_name:
        SpecificProviderData?.trading_name /* provider trading name */,
      provider_fa_id: SpecificProviderData?.provider_fa_id,
      workersInviteData: [
        {
          individual_id: "",
          email: "",
          first_name: "",
          last_name: "",
        },
      ],
      workerClientsIds: "",
    });
    setPersonName([]);
  };

  // Check Existing Email
  const HandleChange = (e) => {
    let searchInp = e?.target?.value
    setSearch(searchInp);
    setvalidateData(false);
    // setcustomOptions({ value: searchInp , label: searchInp || e});


  };
  const HandleChange2 = (e) => {
    setSearch2(e.trim());
    setvalidateData(false);
    setcustomOptions({ value: e.trim(), label: e.trim() });

    if ((e.trim()) !== "" && (e.trim())?.length >= 2) {

      dispatch(
        GetAllIndividualListForWorkerInvites({
          search: (e.trim()),
          provider_org_id: orgId,
          provider_fa_id: SpecificProviderData?.provider_fa_id,
        })
      ).then((response) => {
        if (response.success) {
          const FilterData = response?.data?.map((item) => {
            return {
              label: `${item.first_name}` + "-" + item.email,
              email: item.email,
              first_name: item.first_name,
              individual_id: item.individual_id,
              last_name: item.last_name,
              user_id: item.user_id,
              is_conserve_team: item.is_conserve_team,
              worker_id: item?.worker_id,
              invite_id: item?.invite_id
            };
          });
          setsearchOptions(FilterData);
        } else if (response.status === 401) {
          handleUnauthorizedAccess();
        }
      });
    } else {
      setsearchOptions([]);
    }
  }
  const inputchangehandler = useCallback(debounce(HandleChange), []);

  const inputchangehandler2 = useCallback(debounce(HandleChange2), []);
  const OnSlectHandleChange = (e) => {
    if (e?.value) {
      setinviteData({
        email: e.value,
      });
    } else {
      setinviteData({
        ...e,
        organisation_id: orgId,
        function_assignment_id: SpecificProviderData?.provider_fa_id,
        trading_name:
          SpecificProviderData?.trading_name /* provider trading name */,
      });
    }
  };

  // Form data Handle
  const formHandleData = (e, index, name) => {
    seterrorvalidation((prevalue) => {
      return {
        ...prevalue,
        [e.target.name == "last_name" ? "lastName" : "fistName"]: "",
      };
    });

    setAddWorkerData((prevState) => {
      const updatedWorkersInviteData = [...prevState.workersInviteData];
      if (name == "first_name") {
        updatedWorkersInviteData[index] = {
          ...updatedWorkersInviteData[index],
          first_name: e.target.value,
        };
      } else {
        updatedWorkersInviteData[index] = {
          ...updatedWorkersInviteData[index],
          last_name: e.target.value,
        };
      }

      return {
        ...prevState,
        workersInviteData: updatedWorkersInviteData,
      };
    });
    // setinviteData((prevalue) => {
    //   return {
    //     ...prevalue,
    //     [e.target.name]: e.target.value,

    //     individual_id: "",
    //   };
    // });
  };

  // FilTER DATA SHOW
  const [loadData, setLoadData] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [getAllinvitedData, SetgetAllinvitedData] = useState({
    function_assignment_id: SpecificProviderData?.provider_fa_id,
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: search,
  });

  useEffect(() => {
    if (SpecificProviderData?.provider_fa_id) {
      SetgetAllinvitedData((prev) => ({
        ...prev,
        function_assignment_id: SpecificProviderData.provider_fa_id,
      }));
      setAddWorkerData((prev) => ({
        ...prev,
        trading_name: SpecificProviderData.trading_name,
        provider_fa_id: SpecificProviderData.provider_fa_id,
      }));
    }
  }, [SpecificProviderData]);
  // All ReduxFunction
  useEffect(() => {
    if (singleSegmentValue == "workers") {
      let updateFilter = getAllinvitedData;
      delete updateFilter.statusType;
      delete updateFilter.function_assignment_id;
      updateFilter["provider_org_id"] = orgId;
      updateFilter["search"] = search;
      dispatch(GetAllWorkersOfProvider(updateFilter));
      setLoadData(true);
    } else if (
      singleSegmentValue == "compliant" ||
      singleSegmentValue == "nonCompliant"
    ) {
      let statusType;
      if (singleSegmentValue == "compliant") {
        statusType = "Compliant";
      } else {
        statusType = "NonCompliant";
      }
      let updateFilter = getAllinvitedData;
      delete updateFilter.function_assignment_id;
      updateFilter["provider_org_id"] = orgId;
      updateFilter["statusType"] = statusType;
      updateFilter["search"] = search;
      dispatch(GetAllWorkersOfProvider(updateFilter));
      setLoadData(true);
    } else {
      let updateFilter = getAllinvitedData;
      delete updateFilter.statusType;
      delete updateFilter.provider_org_id;
      updateFilter["function_assignment_id"] =
        SpecificProviderData?.provider_fa_id;
      updateFilter["search"] = search;
      dispatch(GetProviderWorkersInvite(updateFilter));
      setLoadData(true);
    }
  }, [getAllinvitedData, refetch, search]);
  const GetFunction = useSelector((state) => state);
  let totalCompliantCount = 0;

  useEffect(() => {
    if (singleSegmentValue == "compliant") {
      totalCompliantCount =
        GetFunction?.SpecificContractorWorkerInvites?.data?.data?.rows.reduce(
          (total, worker) => {
            const compliantAssignsCount = worker?.client_assigns?.filter(
              (assign) => assign.status?.toLowerCase() === "compliant"
            ).length;

            return total + compliantAssignsCount;
          },
          0
        );
    }
  }, [singleSegmentValue == "compliant"]);
  const handleSort = (column) => {
    if (column === getAllinvitedData.sort) {
      SetgetAllinvitedData((prevalue) => {
        return {
          ...prevalue,
          ["order"]: getAllinvitedData.order === "asc" ? "desc" : "asc",
        };
      });
    } else {
      SetgetAllinvitedData((prevalue) => {
        return {
          ...prevalue,
          ["sort"]: column,
        };
      });
      SetgetAllinvitedData((prevalue) => {
        return {
          ...prevalue,
          ["order"]: getAllinvitedData.order === "asc" ? "desc" : "asc",
        };
      });
    }
  };
  const handlePageChange = ({ selected }) => {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        ["page"]: selected + 1,
      };
    });
    setTotalPages(
      Math.ceil(
        GetFunction.SpecificContractorWorkerInvites?.data?.data?.count ||
        0 / getAllinvitedData.limit
      )
    );
  };

  // Search Data
  const handleSearch = (e) => {
    SetgetAllinvitedData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };
  const inputchangehandlerSearch = useCallback(debounce(handleSearch), []);
  // page, limit, sort, order, search, function_assignment_id  (client function assignment id)

  const getPageNumber = () => {
    setTotalPages(
      Math.ceil(
        GetFunction.SpecificContractorWorkerInvites?.data?.data?.count /
        getAllinvitedData.limit
      )
    );
  };
  useEffect(() => {
    getPageNumber();
  }, [getPageNumber]);

  // Check Tab
  // Update Main Tabs Function
  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setLoadData(false);
      setSingleSegmentValue(val[0]);
      SetgetAllinvitedData((prevalue) => {
        return { ...prevalue, ["sort"]: "created_date" };
      });
    },
    [setSingleSegmentValue]
  );

  // Import CSV Function
  const Toggle = !SpecificProviderData?.is_default_contractor ? (
    <Tooltip title="Unable to add a worker because this organisation does not have a contractor role!">
      <span className="inline-block">
        <Button
          disabled
          className="flex gap-1 texts-nowrap justify-center items-center text-xs w-auto px-3 h-9 bg-blue-50 border-gray-300 rounded-lg border font-semibold hover:bg-gray-50 hover:border-gray-300 focus:bg-white focus:border-gray-300"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.67 10.417v-4.75c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.093-1.093c-.534-.272-1.235-.272-2.635-.272H7.336c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093c-.272.535-.272 1.235-.272 2.635v8.666c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.093c.535.272 1.235.272 2.635.272h3.083m1.25-9.166h-5M8.336 12.5H6.669m6.667-6.667H6.669m5.834 10 2.5 2.5m0 0 2.5-2.5m-2.5 2.5v-5"
              stroke="#344054"
              strokeWidth="1.667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Import CSV
          <svg
            width="20"
            height="20"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m6.394 9 6 6 6-6"
              stroke="#000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </span>
    </Tooltip>
  ) : (
    <Button
      disabled={false}
      className="flex gap-1 texts-nowrap justify-center items-center text-xs w-auto px-3 h-9 bg-blue-50 border-gray-300 rounded-lg border font-semibold hover:bg-gray-50 hover:border-gray-300 focus:bg-white focus:border-gray-300"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.67 10.417v-4.75c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.093-1.093c-.534-.272-1.235-.272-2.635-.272H7.336c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093c-.272.535-.272 1.235-.272 2.635v8.666c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.093c.535.272 1.235.272 2.635.272h3.083m1.25-9.166h-5M8.336 12.5H6.669m6.667-6.667H6.669m5.834 10 2.5 2.5m0 0 2.5-2.5m-2.5 2.5v-5"
          stroke="#344054"
          strokeWidth="1.667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      Import CSV
      <svg
        width="20"
        height="20"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m6.394 9 6 6 6-6"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );

  useEffect(() => {
    if (GetFunction.inviteContractorWorkerCsvData?.data?.data?.success) {
      if (updateCsvData) {
        dialogCloseCSV();
        setAddOpen(true);
        dispatch(reSetData());
        setCsvData([]);
      }
    } else {
      if (
        !GetFunction.inviteContractorWorkerCsvData.loading &&
        GetFunction.inviteContractorWorkerCsvData.data?.data !== undefined
      ) {
        setCsvData(GetFunction.inviteContractorWorkerCsvData.data?.data);
        let filterdata =
          GetFunction?.inviteContractorWorkerCsvData?.data?.data.filter(
            (items) => items.is_validated == true
          );
        // Now, create a new filtered array that excludes the 'action' and 'invite_id' properties
        if (filterdata) {
          const filteredData = filterdata.map((item) => {
            // Create a new object with only the desired properties
            const { action, is_validated, invite_id, ...filteredItem } = item;
            return filteredItem;
          });

          setfinalCsvData(filteredData);
        } else {
          setfinalCsvData([]);
        }
      }
    }
  }, [GetFunction]);

  const openCSV = () => {
    setCSV(true);
  };

  const dialogCloseCSV = (e) => {
    setCSV(false);
    dispatch(reSetData());
    setCsvData([]);
  };

  // Upload CSV File
  const handleFileChange = (e) => {
    dispatch(reSetData());
    setCsvData([]);
    const file = e.target.files[0];
    let payload = {
      provider_org_id: orgId,
      function_assignment_id: SpecificProviderData?.provider_fa_id,
      invite_worker_csv: file,
    };
    dispatch(inviteWorkerCsvView(payload));
    openCSV();
    setUpdateCsvData(false);
  };

  // CSV Default Data Array
  const CSVData = [
    ["first_name", "last_name", "email"],
    ["brandon", "Hodges", "brandon.hodges33@conserv.com"],
    ["victor", "Carr", "victor.carr33@conserv.com"],
    ["Lillian", "Hodges", "lillian.pullman@conserv.com"],
    ["Edward", "Hodges", "edward.mills@conserv.com"],
    ["Megan", "Hodges", "megan.mcdonald4555@conserv.com"],
  ];

  // Function to handle checkbox change
  const handlecheckbox = (event, index) => {
    const isChecked = event;
    const item = csvData[index];
    if (isChecked) {
      // Add the checked item to the array
      setfinalCsvData((prevCheckedItems) => [...prevCheckedItems, item]);
    } else {
      // Remove the unchecked item from the array
      setfinalCsvData((prevCheckedItems) =>
        prevCheckedItems.filter(
          (checkedItem) => checkedItem.email !== item.email
        )
      );
    }
  };
  // Submit CSV Data
  // const submitCsvData = () => {
  //   dispatch(
  //     InviteWorkerFromCsvDetails({
  //       trading_name:
  //         SpecificProviderData?.trading_name /* provider trading name */,
  //       function_assignment_id: SpecificProviderData?.provider_fa_id,
  //       worker_invite_data: finalCsvData,
  //       clientOrgIds: addWorkerData.workerClientsIds,
  //     })
  //   )
  //     .then((response) => {
  //       if (response.success) {
  //         setCSV(false);
  //         dispatch(reSetData());
  //         setCsvData([]);
  //         setAddOpen(true);
  //         onCloseNextCsv();
  //       } else if (response.status === 401) {
  //         handleUnauthorizedAccess();
  //       }
  //     })
  //     .catch((error) => {});
  //   setUpdateCsvData(true);
  // };

  // Submit CSV Data
  const submitCsvData = (step, checkInvite) => {
    // If client pays, bypass payment screen and directly invite workers
    if (personName?.length > 0 && personName[0]?.is_client_pays === true) {
      dispatch(
        InviteWorkerFromCsvDetails({
          provider_type_id: provider_type_id,
          worker_invite_data: finalCsvData,
          trading_name:
            SpecificProviderData?.trading_name /* provider trading name */,
          provider_org_id: orgId,
          current_user: current_user,
          provider_fa_id: SpecificProviderData?.provider_fa_id,
          clientOrgIds: addWorkerData.workerClientsIds,
          subscriptionStatus: subscriptionStatus,
          client_trading_names: personName?.length > 0 ? personName.map((client) => client?.label) : [],
        })
      )
        .then((response) => {
          if (response.success) {
            setCSV(false);
            dispatch(reSetData());
            setCsvData([]);
            setAddOpen(true);
            onCloseNextCsv();
          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => { });
      setUpdateCsvData(true);
      return;
    }

    if (checkInvite) {
      dispatch(
        InviteWorkerFromCsvDetails({
          provider_type_id: provider_type_id,
          worker_invite_data: finalCsvData,
          trading_name:
            SpecificProviderData?.trading_name /* provider trading name */,
          provider_org_id: orgId,
          current_user: current_user,
          provider_fa_id: SpecificProviderData?.provider_fa_id,
          clientOrgIds: addWorkerData.workerClientsIds,
          // is_licence_paid_by_provider: isProvLicencePaid,
          subscriptionStatus: subscriptionStatus,
          client_trading_names: personName?.length > 0 ? personName.map(client => client?.label) : [],

        })
      )
        .then((response) => {
          if (response.success) {
            setCSV(false);
            dispatch(reSetData());
            setCsvData([]);
            setAddOpen(true);
            onCloseNextCsv();
          } else if (response.status === 401) {
            handleUnauthorizedAccess();
          }
        })
        .catch((error) => { });
      setUpdateCsvData(true);
    } else {
      if (step == 0) {
        setStepForm(1);
      }
    }
  };

  const onCloseNextCsv = () => {
    setStepForm(0);
    setPersonName([]);
    setDialogNextCsv(false);
    setfinalCsvData([]);
  };

  const selectionClient = (selectedOption) => {
    setSelectedClientType(selectedOption);
  };

  const addWorker = () => {
    setAddWorkerData((prevState) => ({
      ...prevState,
      workersInviteData: [
        ...prevState.workersInviteData,
        { individual_id: "", email: "", first_name: "", last_name: "" },
      ],
    }));
  };

  const DeleteWorker = (indexToRemove) => {
    setAddWorkerData((prevState) => {
      const updatedWorkersInviteData = prevState.workersInviteData.filter(
        (_, index) => index !== indexToRemove
      );

      // Clear and reindex errors
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        // Remove errors for the worker being deleted
        delete updatedErrors[`firstNameError_${indexToRemove}`];
        delete updatedErrors[`lastNameError_${indexToRemove}`];
        delete updatedErrors[`emailError_${indexToRemove}`];
        delete updatedErrors[`conserveTeamError_${indexToRemove}`];
        delete updatedErrors[`alreadyWorkerError_${indexToRemove}`];
        delete updatedErrors[`alreadyInvitedError_${indexToRemove}`];

        // Reindex errors for the remaining workers
        const reindexedErrors = Object.keys(updatedErrors).reduce(
          (acc, key) => {
            const match = key.match(
              /^(firstNameError|lastNameError|emailError|conserveTeamError|alreadyWorkerError|alreadyInvitedError)_(\d+)$/
            );
            if (match) {
              const currentIndex = parseInt(match[2], 10);
              if (currentIndex > indexToRemove) {
                // Shift the index down for workers after the deleted one
                const newIndex = currentIndex - 1;
                const newKey = `${match[1]}_${newIndex}`;
                acc[newKey] = updatedErrors[key];
              } else if (currentIndex !== indexToRemove) {
                // Keep the same for workers before the deleted one
                acc[key] = updatedErrors[key];
              }
            } else {
              // Copy any unrelated errors
              acc[key] = updatedErrors[key];
            }
            return acc;
          },
          {}
        );
        return reindexedErrors;
      });

      return {
        ...prevState,
        workersInviteData: updatedWorkersInviteData,
      };
    });
  };

  const handleChange = (event) => {
    seterrorvalidation((prevalue) => {
      return {
        ...prevalue,
        ["workerClientsIds"]: "",
      };
    });
    const EventValue = event.target.value;
    const filterdata = EventValue.map((item, index) => {
      return item;
    });
    setPersonName(filterdata.flat());

    setAddWorkerData((prevalue) => {
      return {
        ...prevalue,
        ["workerClientsIds"]: filterdata.flat().map((item) => item.value),
      };
    });
  };

  const openMultiSelect = () => {
    dispatch(
      GetAllClientsOfProviderList({
        provider_fa_id: SpecificProviderData?.provider_fa_id,
        isReqSeatCount: true,
        provider_org_id: orgId,
      })
    )
      .then((response) => {
        if (response.success) {
          const arrayData = response?.data?.clientsRes;
          setAssignedWorkers(response?.data?.invitedWorkers);
          setseatCount(Math.max(0, response?.data?.seatCount - response?.data?.invitedWorkers));
          setSubscriptionStatus(response?.data?.subscriptionStatus)
          // setIsProvLicencePaid(response?.data?.isProvLicencePaid);
          setProvider_type_id(response?.data?.provider_type_id);
          let client_data = [];
          for (let key in arrayData) {
            client_data.push({
              label: arrayData[key].trading_name,
              value: arrayData[key].organisation_id,
              organisation_id: arrayData[key].organisation_id,
              function_assignment_id: arrayData[key].function_assignment_id,
              is_client_pays: arrayData[key].is_client_pays,
            });
          }
          const listData = [];
          if (client_data) {
            client_data.map((item) => {
              if (item.function_assignment_id) {
                listData.push(item);
              }
            });
          }
          setAllClient(listData);
        } else if (response.status === 401) {
          handleUnauthorizedAccess();
        }
      })
      .catch((error) => { });
  };

  // Custom option for the input value for email/abn for 1st page & email for 2nd page
  const customOption = { value: search || search2, label: search || search2 };
  // Check if the inputValue exists in options, if not, add it
  const updatedOptions = searchOptions?.find(
    (option) => option.value === search || search2
  )
    ? searchOptions
    : [...searchOptions, customOption];

  // function for Select tag for email/abn for 1st page & email for 2nd page
  const handleSearchChange = (newInputValue) => {
    setSearch(newInputValue);
  };

  const handleSelectChange = (selectedOption, index) => {

    if (selectedOption?.is_conserve_team) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`conserveTeamError_${index}`] =
          "Conserve team members cannot be added";
        return updatedErrors;
      });
    } else {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`conserveTeamError_${index}`] = "";
        return updatedErrors;
      });
    }
    // Already Worker associated with this provider Error
    if (selectedOption?.worker_id) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyWorkerError_${index}`] =
          "This worker is already associated with this provider. Please select a different worker.";
        return updatedErrors;
      });
    } else {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyWorkerError_${index}`] = "";
        return updatedErrors;
      });
    }
    if (selectedOption?.invite_id) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyInvitedError_${index}`] =
          "This worker is already invited with this provider. Please select a different worker.";
        return updatedErrors;
      });
    } else {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`alreadyInvitedError_${index}`] = "";
        return updatedErrors;
      });
    }
    let emailAlreadyExist = false;
    setAddWorkerData((prevValue) => {
      const emailToValidate = selectedOption?.label || selectedOption?.email;
      const actualEmail = emailToValidate ? emailToValidate?.split('-')[1] : "";

      // Check for duplicate email
      const emailMatch = prevValue?.workersInviteData?.some(
        (ele) => ele?.email === actualEmail
      );

      if (emailMatch) {
        setCheckError(false)
        setErrorValidation((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          updatedErrors[`emailError_${index}`] =
            "This email address has already been entered.";
          // updatedErrors[`conserveTeamError_${index}`] = ""
          emailAlreadyExist = true;
          return updatedErrors;
        });

        return prevValue; // Return the previous state to avoid changes
      }


      function isEmail(value) {
        if (value !== undefined && value !== "") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(value);
        }
        return false;
      }

      // Validate email format
      if (emailToValidate && !isEmail(selectedOption?.email || emailToValidate)) {
        setErrorValidation((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          updatedErrors[`emailError_${index}`] =
            "Please insert a valid email address";
          emailAlreadyExist = true;
          return updatedErrors;
        });

        return prevValue; // Return the previous state to avoid changes
      }

      // Create a copy of the workersInviteData array
      const updatedWorkersInviteData = prevValue.workersInviteData.map(
        (item, i) => {
          // Check if the current index matches the specified index
          if (i === index) {
            // Return a new object with the updated value
            return {
              ...item,
              // Assuming selectedOption contains the updated values (e.g., email, first_name, etc.)
              ...selectedOption,
              ["email"]:
                selectedOption == null
                  ? ""
                  : selectedOption.value != undefined
                    ? selectedOption.value
                    : selectedOption.email,
            };
          }
          // Return the unchanged item for other indices
          return item;
        }
      );

      // Return the updated state
      return {
        ...prevValue,
        workersInviteData: updatedWorkersInviteData,
      };
    });
    // Clear worker-specific errors
    if (
      selectedOption?.email &&
      selectedOption?.first_name &&
      selectedOption?.last_name
    ) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`firstNameError_${index}`] = "";
        updatedErrors[`lastNameError_${index}`] = "";
        return updatedErrors;
      });
    }

    if (selectedOption?.label && emailAlreadyExist == false) {
      setErrorValidation((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[`emailError_${index}`] = "";
        return updatedErrors;
      });
    }
  };

  // Submit CSV Data
  const submitCsvDataNext = () => {
    // open new pannel
    dialogCloseCSV();
    setDialogNextCsv(true);
  };



  const hasConserveTeamError = Object.keys(errorValidation).some(
    (key) => key.startsWith("conserveTeamError_") && errorValidation[key]
  );
  const hasAlreadyWorkerError = Object.keys(errorValidation).some(
    (key) => key.startsWith("alreadyWorkerError_") && errorValidation[key]
  );
  const hasAlreadyInvitedError = Object.keys(errorValidation).some(
    (key) => key.startsWith("alreadyInvitedError_") && errorValidation[key]
  );
  useEffect(() => {
    if (dialogIsOpen || dialogOpenCSV) {
      openMultiSelect();
    }
  }, [dialogIsOpen, dialogOpenCSV]);

  return (
    <React.Fragment>
      <div className="flex justify-between mb-5">
        <div className="flex gap-2">
          <Segment
            value={singleSegmentValue}
            onChange={(val) => onSingleSelectionSegmentChange(val)}
          >
            <Segment.Item
              value="workers"
              className="h-9 px-3 flex items-center justify-center text-center leading-4"
            >
              <span>View All</span>
            </Segment.Item>
            <Segment.Item
              value="compliant"
              className="h-9 px-3 flex items-center justify-center text-center leading-4"
            >
              <span>Compliant</span>
            </Segment.Item>
            <Segment.Item
              value="nonCompliant"
              className="h-9 px-3 flex items-center justify-center text-center leading-4"
            >
              <span>Non-Compliant</span>
            </Segment.Item>
            <Segment.Item
              value="Invited"
              className="h-9 px-3 flex items-center justify-center text-center leading-4"
            >
              <span>Invited Workers</span>
            </Segment.Item>
          </Segment>
          <div className="w-80 h-10">
            <div className="input-wrapper">
              <div className="input-suffix-start left-3.5">
                <img
                  src="/assets/icons-svg/search-lg.svg"
                  alt=""
                  className="h-5"
                />
              </div>
              <ClientInput
                type="text"
                className="input  pl-10 w-80  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Search"
                inputchangehandler={inputchangehandler}
                name={"search"}
              />
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <div className="flex gap-2 reset-dropdown items-center">
            <Dropdown
              renderTitle={Toggle}
              isOpen={true}
              disabled={!SpecificProviderData?.is_default_contractor}
            >
              <Dropdown.Item eventKey="a">
                <CSVLink
                  className="client_portal_csv"
                  data={CSVData.map((row) =>
                    row.filter((column) => column !== "action")
                  )}
                  filename={"Sample file for worker invite.csv"}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 10V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V10M11.3333 6.66667L8 10M8 10L4.66667 6.66667M8 10V2"
                      stroke="#344054"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>Download template</span>
                </CSVLink>
              </Dropdown.Item>
              <Dropdown.Item eventKey="b">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.33317 1.51318V4.26688C9.33317 4.64025 9.33317 4.82693 9.40583 4.96954C9.46975 5.09498 9.57173 5.19697 9.69718 5.26088C9.83978 5.33354 10.0265 5.33354 10.3998 5.33354H13.1535M5.99984 10.0002L7.99984 12.0002M7.99984 12.0002L9.99984 10.0002M7.99984 12.0002L7.99984 8.00016M9.33317 1.3335H5.8665C4.7464 1.3335 4.18635 1.3335 3.75852 1.55148C3.3822 1.74323 3.07624 2.04919 2.88449 2.42552C2.6665 2.85334 2.6665 3.41339 2.6665 4.5335V11.4668C2.6665 12.5869 2.6665 13.147 2.88449 13.5748C3.07624 13.9511 3.3822 14.2571 3.75852 14.4488C4.18635 14.6668 4.7464 14.6668 5.8665 14.6668H10.1332C11.2533 14.6668 11.8133 14.6668 12.2412 14.4488C12.6175 14.2571 12.9234 13.9511 13.1152 13.5748C13.3332 13.147 13.3332 12.5869 13.3332 11.4668V5.3335L9.33317 1.3335Z"
                    stroke="#344054"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {/* Import file */}
                <span>Import file</span>
                <input
                  className="upload_csv"
                  type="file"
                  accept=".csv"
                  onChange={handleFileChange}
                />
              </Dropdown.Item>
            </Dropdown>
            <BtnPrimary
              disabled={!SpecificProviderData?.is_default_contractor}
              onClick={() => openDialog()}
              className="px-2 ml-2 w-32 text-12 h-9 justify-center flex gap-2 items-center"
            >
              {!SpecificProviderData?.is_default_contractor ? (
                <Tooltip title="Unable to add a worker because this organisation does not have a contractor role!">
                  <span className="flex items-center gap-2">
                    Add worker
                    <img src="/assets/icons-svg/plus.svg" alt="Add" />
                  </span>
                </Tooltip>
              ) : (
                <>
                  Add worker
                  <span>
                    <img src="/assets/icons-svg/plus.svg" alt="Add" />
                  </span>
                </>
              )}
            </BtnPrimary>

            <div className="export-dropdow ml-2 flex items-center">
              <Dropdown
                title={isExportingWorkers ? "Exporting" : "Export"}
                className="dropdown-btn"
                disabled={isExportingWorkers}
              >
                <Dropdown.Item
                  eventKey="a"
                  onClick={() => handleExportAllWorkers("csv")}
                  className="text-gray-900 font font-medium"
                >
                  CSV
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="b"
                  onClick={() => handleExportAllWorkers("excel")}
                  className="text-gray-900 font font-medium"
                >
                  Excel
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="c"
                  onClick={() => handleExportAllWorkers("pdf")}
                  className="text-gray-900 font font-medium"
                >
                  PDF
                </Dropdown.Item>
              </Dropdown>
              <CSVLink
                data={exportCsvRows}
                headers={exportWorkersCsvHeaders}
                filename={`provider-workers-${orgId}.csv`}
                ref={exportCsvLinkRef}
                className="hidden"
              />
            </div>

          </div>
        </div>
      </div>

      {singleSegmentValue == "Invited" && (
        <React.Fragment>
          <WorkersList
            handleSort={handleSort}
            getAllinvitedData={getAllinvitedData}
            singleSegmentValue={singleSegmentValue}
            setrefetch={setrefetch}
            refetch={refetch}
          />
          {!loadData && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}
          {loadData && (
            <div className="flex justify-between mt-3">
              <Pagination
                totalCount={
                  GetFunction.SpecificContractorWorkerInvites?.data?.data
                    ?.count || 0
                }
                pageNumber={getAllinvitedData.page}
                displayPage={
                  GetFunction.SpecificContractorWorkerInvites?.data?.data?.rows
                    ?.length || 0
                }
                UpdatePageLimit={SetgetAllinvitedData}
                allfilters={getAllinvitedData}
              />
              {GetFunction.SpecificContractorWorkerInvites?.data?.data?.count >
                0 && (
                  <ReactPaginate
                    className="flex justify-content-end p-2 align-items-center pagination-wrap"
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    // pageLinkClassName={'page-link'}
                    previousLinkClassName={"prev-link"}
                    nextLinkClassName={"page-link"}
                    breakLinkClassName={"prev-link"}
                    previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    pageLinkClassName={"px-4 rounded-md"}
                    activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
                    disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
                  />
                )}
            </div>
          )}
        </React.Fragment>
      )}
      {singleSegmentValue == "nonCompliant" && (
        <React.Fragment>
          <NonCompliantList
            handleSort={handleSort}
            getAllinvitedData={getAllinvitedData}
            singleSegmentValue={singleSegmentValue}
            setrefetch={setrefetch}
            refetch={refetch}
          />
          {/* {!loadData && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}
          {loadData && (
            <div className="flex justify-between mt-3">
              <Pagination
                totalCount={
                  GetFunction.SpecificContractorWorkerInvites?.data?.data
                    ?.count || 0
                }
                pageNumber={getAllinvitedData.page}
                displayPage={
                  GetFunction.SpecificContractorWorkerInvites?.data?.data?.rows
                    ?.length || 0
                }
                UpdatePageLimit={SetgetAllinvitedData}
                allfilters={getAllinvitedData}
              />
              {GetFunction.SpecificContractorWorkerInvites?.data?.data?.count >
                0 && (
                  <ReactPaginate
                    className="flex justify-content-end p-2 align-items-center pagination-wrap"
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    previousLinkClassName={"prev-link"}
                    nextLinkClassName={"page-link"}
                    breakLinkClassName={"prev-link"}
                    previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    pageLinkClassName={"px-4 rounded-md"}
                    activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
                    disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
                  />
                )}
            </div>
          )} */}
        </React.Fragment>
      )}
      {singleSegmentValue == "compliant" && (
        <React.Fragment>
          <CompliantList
            handleSort={handleSort}
            getAllinvitedData={getAllinvitedData}
            singleSegmentValue={singleSegmentValue}
            setrefetch={setrefetch}
            refetch={refetch}
          />
          {/* {!loadData && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}

          {loadData && (
            <div className="flex justify-between mt-3">
              <Pagination
                totalCount={totalCompliantCount || 0}
                pageNumber={getAllinvitedData.page}
                displayPage={totalCompliantCount || 0}
                UpdatePageLimit={SetgetAllinvitedData}
                allfilters={getAllinvitedData}
              />
             
              {totalCompliantCount > 0 &&
                GetFunction.SpecificContractorWorkerInvites?.data?.data?.count >
                0 && (
                  <ReactPaginate
                    className="flex justify-content-end p-2 align-items-center pagination-wrap"
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    // pageLinkClassName={'page-link'}
                    previousLinkClassName={"prev-link"}
                    nextLinkClassName={"page-link"}
                    breakLinkClassName={"prev-link"}
                    previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    pageLinkClassName={"px-4 rounded-md"}
                    activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
                    disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
                  />
                )}
            </div>
          )} */}
        </React.Fragment>
      )}
      {singleSegmentValue == "workers" && (
        <React.Fragment>
          <ViewAll
            handleSort={handleSort}
            getAllinvitedData={getAllinvitedData}
            singleSegmentValue={singleSegmentValue}
            setrefetch={setrefetch}
            refetch={refetch}
          />
          {!loadData && (
            <div>
              <ThreeDotBouncing />
            </div>
          )}
          {loadData && (
            <div className="flex justify-between mt-3">
              <Pagination
                totalCount={
                  GetFunction.SpecificContractorWorkerInvites?.data?.data
                    ?.count || 0
                }
                pageNumber={getAllinvitedData.page}
                displayPage={
                  GetFunction.SpecificContractorWorkerInvites?.data?.data?.rows
                    ?.length || 0
                }
                UpdatePageLimit={SetgetAllinvitedData}
                allfilters={getAllinvitedData}
              />
              {GetFunction.SpecificContractorWorkerInvites?.data?.data?.count >
                0 && (
                  <ReactPaginate
                    className="flex justify-content-end p-2 align-items-center pagination-wrap"
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    // pageLinkClassName={'page-link'}
                    previousLinkClassName={"prev-link"}
                    nextLinkClassName={"page-link"}
                    breakLinkClassName={"prev-link"}
                    previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
                    pageLinkClassName={"px-4 rounded-md"}
                    activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
                    disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
                  />
                )}
            </div>
          )}
        </React.Fragment>
      )}

      <Dialog
        isOpen={dialogIsOpen}
        onClose={onDialogClose}
        onRequestClose={() => { }}
        bodyOpenClassName="overflow-hidden"
        className="addContact-dialog"
      >
        <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <img src="/assets/icons-svg/file-check.svg" alt="" />
          </span>
          <div>
            <h5 className="mb-1 text-gray-900 text-base font-semibold">
              Invite a Worker
            </h5>
          </div>
        </div>
        {stepForm == 0 && (
          <div className="px-6">
            <div className="mb-5">
              <div className="flex items-center gap-2 mb-1">
                <label className="font-medium text-gray-700 block">
                  Client*
                </label>
                <Tooltip title="Only clients with the same payment type can be selected when choosing multiple clients." placement="top-start">
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#bcclap1iaa)">
                        <path
                          d="M6.06 6a2 2 0 0 1 3.887.667c0 1.333-2 2-2 2M8 11.333h.007M14.667 8A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0z"
                          stroke="#98A2B3"
                          strokeWidth="1.333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="bcclap1iaa">
                          <path fill="#fff" d="M0 0h16v16H0z" />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                </Tooltip>
              </div>
              <div className="w-full hide-seacrh-icon mt-2 h-8">
                <MultiSelect
                  className="w-full"
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={personName}
                  onChange={handleChange}
                  // onOpen={() => {
                  //   openMultiSelect();
                  // }}
                  input={<OutlinedInput label="Tag" />}
                  renderValue={(selected) =>
                    selected.map((item) => item.label).join(", ")
                  } // Display only names
                  MenuProps={MenuProps}
                >
                  {allClient?.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item}
                      disabled={
                        personName?.length > 0 &&
                        item?.is_client_pays !== personName[0]?.is_client_pays
                      }
                    >
                      <Checkbox
                        checked={
                          personName.findIndex(
                            (selectedItem) => selectedItem.label === item.label
                          ) > -1
                        }
                      />
                      <ListItemText primary={item.label} />
                    </MenuItem>
                  ))}
                </MultiSelect>
              </div>
              {errorvalidation.workerClientsIds && (
                <div className="text-red-500 text-sm mt-1 ">
                  {errorvalidation.workerClientsIds}
                </div>
              )}
            </div>
            <div className="flex items-center mb-1">
              <label className="font-medium text-gray-700 block ">
                Workers
              </label>
              <span
                className={
                  "badge tag text-warning-700 bg-warning-50 py-0.5 px-2 rounded-full font-medium"
                }
              >
                {(personName?.length > 0 && personName[0]?.is_client_pays === true)
                  ? `${totalWorker}`
                  : `${totalWorker}/${seatCount} `} assigned
              </span>
            </div>

            {addWorkerData?.workersInviteData?.map((item, index) => {
              return (
                <React.Fragment>
                  <div className="py-2">
                    <label className="font-medium text-gray-700 block mb-1 mt-2">
                      Email*
                    </label>
                    <div className="flex gap-2 items-center">
                      <div className="w-full">
                        <Select
                          isSearchable={true}
                          placeholder="Search for a worker"
                          className="w-full h-10 select-options"
                          isClearable={true}
                          options={
                            updatedOptions ? updatedOptions : selectedOption
                          }
                          value={{
                            label: item?.first_name
                              ? item?.email
                              : item.label
                                ? item.label
                                : "",
                            // label:`${item?.first_name}` + "-" + item?.email,
                            email: item?.email,
                            individual_id: item?.individual_id,
                            is_conserve_team: item?.is_conserve_team,
                            invite_id: item?.invite_id,
                          }}
                          onChange={(e) => handleSelectChange(e, index)}
                          handleSearchChange={inputchangehandler2}
                        // onBlur={handleBlurForEmail}
                        />

                      </div>

                      {addWorkerData?.workersInviteData.length > 1 && (
                        <Button onClick={() => DeleteWorker(index)}>
                          <svg
                            width="19"
                            height="20"
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 3.5h6m-12 3h18m-2 0-.701 10.52c-.105 1.578-.158 2.367-.499 2.965a3 3 0 0 1-1.298 1.215c-.62.3-1.41.3-2.993.3h-3.018c-1.582 0-2.373 0-2.993-.3A3 3 0 0 1 6.2 19.985c-.34-.598-.394-1.387-.499-2.966L5 6.5m5 4.5v5m4-5v5"
                              stroke="#667085"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </Button>
                      )}
                    </div>
                    <div className="flex flex-row gap-1 mt-1">
                      {/* First priority: alreadyWorkerError */}
                      {errorValidation[`alreadyWorkerError_${index}`] && (
                        <div className="text-red-500 text-sm">
                          {errorValidation[`alreadyWorkerError_${index}`]}
                        </div>
                      )}

                      {/* Second priority: conserveTeamError */}
                      {!errorValidation[`alreadyWorkerError_${index}`] &&
                        errorValidation[`conserveTeamError_${index}`] && (
                          <div className="text-red-500 text-sm">
                            {errorValidation[`conserveTeamError_${index}`]}
                          </div>
                        )}

                      {/* Third priority: emailError */}
                      {!errorValidation[`alreadyWorkerError_${index}`] &&
                        !errorValidation[`conserveTeamError_${index}`] &&
                        errorValidation[`emailError_${index}`] && (
                          <div className="text-red-500 text-sm">
                            {errorValidation[`emailError_${index}`]}
                          </div>
                        )}

                      {/* Fourth priority: alreadyInvitedError */}
                      {!errorValidation[`alreadyWorkerError_${index}`] &&
                        !errorValidation[`conserveTeamError_${index}`] &&
                        !errorValidation[`emailError_${index}`] &&
                        errorValidation[`alreadyInvitedError_${index}`] && (
                          <div className="text-red-500 text-sm">
                            {errorValidation[`alreadyInvitedError_${index}`]}
                          </div>
                        )}
                    </div>

                    {/* <div className="text-red-500 text-sm mt-1">
                      {(() => {
                        if (checkError && !item.email) {
                          return 'This field is required!';
                        }

                        const alreadyError = errorValidation[`alreadyWorkerError_${index}`];
                        const conserveError = errorValidation[`conserveTeamError_${index}`];
                        const emailError = errorValidation[`emailError_${index}`];

                        if (alreadyError) {
                          return alreadyError;
                        } else if (conserveError) {
                          return conserveError;
                        } else if (emailError) {
                          return emailError;
                        } else {
                          return null;
                        }
                      })()}
                    </div> */}
                    {
                      // !item?.individual_id && (
                      <div className="flex gap-2 mt-2">
                        <div className="w-3/6 ">
                          <label className="font-medium text-gray-700 block mb-1">
                            First name*
                          </label>
                          <ClientInput
                            name="first_name"
                            readOnly={item?.individual_id ? true : false}
                            inputchangehandler={(e) => {
                              formHandleData(e, index, "first_name");
                            }}
                            value={item.first_name}
                            className="h-9 w-full"
                            placeholder="Enter contact's first name"
                          />
                          {checkError && !item.first_name && (
                            <div className="text-red-500 text-sm mt-1 ">
                              This field is required!
                            </div>
                          )}
                        </div>
                        <div className=" w-3/6">
                          <label className="font-medium text-gray-700 block mb-1">
                            Last name*
                          </label>
                          <ClientInput
                            name="last_name"
                            readOnly={item?.individual_id ? true : false}
                            inputchangehandler={(e) => {
                              formHandleData(e, index, "last_name");
                            }}
                            value={item.last_name}
                            className="h-9 w-full"
                            placeholder="Enter contact's last name"
                          />
                          {checkError && !item.last_name && (
                            <div className="text-red-500 text-sm mt-1 ">
                              This field is required!
                            </div>
                          )}
                        </div>
                      </div>
                      // )
                    }
                  </div>
                </React.Fragment>
              );
            })}

            {(!(personName?.length > 0 && personName[0]?.is_client_pays === true) && totalWorker > seatCount) && (
              <div className="mb-3">
                <span
                  className={
                    "badge text-error-700 py-0 px-0 rounded-full font-medium"
                  }
                >
                  Note: You will need to add additional seats to invite this worker. You'll be prompted to make payment on the next screen.
                </span>
              </div>
            )}

            <button
              disabled={
                (subscriptionStatus == "expired" && totalWorker > seatCount && !(personName?.length > 0 && personName[0]?.is_client_pays === true))
              }
              className="text-blue-700 text-xs font-semibold flex items-center gap-2 mt-5"
              onClick={addWorker}
            >
              <span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 4.167v11.666M4.167 10h11.666"
                    stroke="#5786CC"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </span>
              Add another Worker
            </button>
            {/* changes in worker 13-06-25 */}
            {subscriptionStatus == "expired" && totalWorker > seatCount && (
              <div className="text-red-500 text-sm mt-1">
                {/* The provider has not paid the license fee. */}
                Your subscription has expired. Please renew your subscription.
              </div>
            )}
          </div>
        )}

        {stepForm == 1 && !(personName?.length > 0 && personName[0]?.is_client_pays === true) && (
          <Elements stripe={stripePromise}>
            <PaymentMethod
              personName={personName}
              newSeat={totalWorker - seatCount}
              provider_type_id={provider_type_id}
              openUnsaveDialog={openUnsaveDialog}
              updateObject={{
                ...addWorkerData,
                trading_name:
                  SpecificProviderData?.trading_name /* provider trading name */,
                provider_org_id: orgId,
                current_user: current_user,
                provider_fa_id: SpecificProviderData?.provider_fa_id,
                client_trading_names: personName?.length > 0 ? personName.map(client => client?.label) : [],

              }}
              subscriptionStatus={subscriptionStatus}
            />
          </Elements>
        )}

        {stepForm != 1 && (
          <div className="flex dailog-footer">
            <BtnLight
              className="mr-1.5 px-4"
              variant="plain"
              onClick={openUnsaveDialog}
            >
              Cancel
            </BtnLight>
            <BtnPrimary
              disabled={hasConserveTeamError || hasAlreadyWorkerError || hasAlreadyInvitedError ||
                (subscriptionStatus == "expired" && totalWorker > seatCount && true)}
              onClick={() =>
                openAddDialog(
                  stepForm == 1 ? "payment" : 0,
                  totalWorker <= seatCount
                )
              }
              className="ml-1.5 px-4 flex gap-2 items-center justify-center"
              type="submit"
            >
              {totalWorker <= seatCount ? "Invite" : "Next"}
            </BtnPrimary>
          </div>
        )}
      </Dialog>

      {/* CSV Dilog Box */}
      <Dialog
        isOpen={dialogOpenCSV}
        onClose={dialogCloseCSV}
        onRequestClose={dialogCloseCSV}
        bodyOpenClassName="overflow-hidden"
      >
        <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.67 10.417v-4.75c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.093-1.093c-.534-.272-1.235-.272-2.635-.272H7.336c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093c-.272.535-.272 1.235-.272 2.635v8.666c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.093c.535.272 1.235.272 2.635.272h3.083m1.25-9.166h-5M8.336 12.5H6.669m6.667-6.667H6.669m5.834 10 2.5 2.5m0 0 2.5-2.5m-2.5 2.5v-5"
                stroke="#344054"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <div>
            <h5 className="mb-0 text-gray-900 text-base font-semibold">
              CSV Upload
            </h5>
            <p>Workers</p>
          </div>
        </div>
        {(finalCsvData.length) > seatCount && (
          <div
            className={
              "badge tag text-error-700 py-0.5 px-2 rounded-full font-medium ml-2 mb-2"
            }
          >
            To add an additional worker, you'll be prompted to make payment on the next screen. ({finalCsvData.length}/{seatCount}{" "}
            seats)
          </div>
        )}
        {/* changes in worker 13-06-25 */}
        {subscriptionStatus == "expired" && (finalCsvData.length) > seatCount && (
          <div className="text-error-700 text-sm mt-1 ml-5 mb-2">
            Your subscription has expired. Please renew your subscription
          </div>
        )}
        <div className="h-96 pr-2">
          <Scrollbar>
            <div className="px-4">
              <div className="overflow-hidden border rounded-lg border-gray-200">
                <Table>
                  <THead>
                    <Tr>
                      <Th className="w-1/3">
                        <span className="flex items-center gap-1">
                          First name
                          <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                              stroke="#475467"
                              strokeWidth="1.333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </Th>
                      <Th className="w-1/3">
                        <span className="flex items-center gap-1">
                          Last name
                        </span>
                      </Th>
                      <Th className="w-1/3">
                        <span className="flex items-center gap-1">Email</span>
                      </Th>
                      <Th className="w-1/3">
                        <span className="flex items-center gap-1">Action</span>
                      </Th>
                    </Tr>
                  </THead>
                  <TBody>
                    {csvData?.map((item, index) => {
                      return (
                        <React.Fragment>
                          <Tr key={index}>
                            <Td>{item.first_name}</Td>
                            <Td>{item.last_name}</Td>
                            <Td>{item.email}</Td>
                            <Td>
                              {item.is_validated ? (
                                <Checkbox
                                  defaultChecked={true}
                                  onChange={(event) => {
                                    handlecheckbox(event, index);
                                  }}
                                />
                              ) : (
                                <svg
                                  width="24"
                                  height="25"
                                  viewBox="0 0 24 25"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="m18 6.5-12 12m0-12 12 12"
                                    stroke="red"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              )}
                            </Td>
                          </Tr>
                        </React.Fragment>
                      );
                    })}
                  </TBody>
                </Table>
              </div>
              {!finalCsvData.length && (
                <div className="text-red-500 text-sm mt-2">
                  Some of the records seem to be incorrect. Please check the
                  uploaded file again.
                </div>
              )}
            </div>
          </Scrollbar>
        </div>

        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={() => dialogCloseCSV()} className="mr-1.5">
            Cancel
          </BtnLight>
          {/* changes in worker 13-06-25 */}
          <BtnPrimary
            disabled={!finalCsvData.length || subscriptionStatus == "expired"}
            onClick={() => submitCsvDataNext()}
          >
            Next
          </BtnPrimary>
        </div>
      </Dialog>

      {/* Invite Provider import csv */}
      <Dialog
        isOpen={dialogNextCsv}
        onClose={onCloseNextCsv}
        onRequestClose={() => { }}
        bodyOpenClassName="overflow-hidden"
        width={720}
      >
        <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_12450_78578)">
                <path
                  d="M19.1658 20.8745C19.9709 20.8745 20.6214 20.2225 20.6214 19.4191V15.5467C20.6214 14.7434 19.9709 14.0914 19.1658 14.0914H13.3557C12.5506 14.0914 11.9 14.7434 11.9 15.5467V19.4191C11.9 20.2225 12.5506 20.8745 13.3557 20.8745H19.1658ZM19.1658 19.5128H13.3557C13.304 19.5128 13.262 19.4707 13.262 19.4191V15.5467C13.262 15.4951 13.304 15.4531 13.3557 15.4531H19.1658C19.2174 15.4531 19.2594 15.4951 19.2594 15.5467V19.4191C19.2594 19.4707 19.2174 19.5128 19.1658 19.5128Z"
                  fill="#0E4E9A"
                  stroke="#0E4E9A"
                  stroke-width="0.2"
                />
                <path
                  d="M19.2593 15.5458C19.2593 16.0251 18.8703 16.4141 18.391 16.4141H14.1303C13.651 16.4141 13.262 16.0251 13.262 15.5458C13.262 15.1699 12.9569 14.8648 12.581 14.8648C12.2051 14.8648 11.9 15.1699 11.9 15.5458C11.9 16.7769 12.8992 17.7761 14.1303 17.7761H18.391C19.6221 17.7761 20.6213 16.7769 20.6213 15.5458C20.6213 15.1699 20.3162 14.8648 19.9403 14.8648C19.5644 14.8648 19.2593 15.1699 19.2593 15.5458Z"
                  fill="#0E4E9A"
                  stroke="#0E4E9A"
                  stroke-width="0.2"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M17.81 14.889C18.1307 14.889 18.391 14.6287 18.391 14.308V13.5333C18.391 12.785 17.7852 12.1777 17.0354 12.1777H15.486C14.7362 12.1777 14.1304 12.785 14.1304 13.5333V14.308C14.1304 14.6287 14.3907 14.889 14.7114 14.889H17.81ZM17.229 13.8727H15.2924V13.5333C15.2924 13.4265 15.3792 13.3397 15.486 13.3397H17.0354C17.1422 13.3397 17.229 13.4265 17.229 13.5333V13.8727Z"
                  fill="#0E4E9A"
                  stroke="#0E4E9A"
                  stroke-width="0.2"
                />
                <path
                  d="M10.78 14.0664C8.90316 14.098 5.33487 14.7346 3.56036 18.5573C3.34841 19.0142 3.38479 19.737 4.73027 19.776C6.07575 19.815 8.606 19.7923 10.166 19.776"
                  stroke="#0E4E9A"
                  stroke-width="1.95"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <circle
                  cx="11.5698"
                  cy="7.90674"
                  r="3.75986"
                  stroke="#0E4E9A"
                  stroke-width="1.95"
                />
              </g>
              <defs>
                <clipPath id="clip0_12450_78578">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <div>
            <h5 className="mb-0 text-gray-900 text-base font-semibold">
              Add Workers
            </h5>
            <p>
              Ensure workers are categorised correctly and send an optional
              invitation message.
            </p>
          </div>
        </div>
        {stepForm == 0 && (
          <div className="pl-4">
            <div className="h-24">
              <ScrollBar>
                <div className="pr-6 pl-2">
                  <div className="mb-3">
                    <label className="font-medium text-gray-700 mb-1 block">
                      Client
                    </label>
                    <div className="w-full hide-seacrh-icon">
                      <MultiSelect
                        className="w-full"
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={personName}
                        onChange={handleChange}
                        // onOpen={() => {
                        //   openMultiSelect();
                        // }}
                        input={<OutlinedInput label="Tag" />}
                        renderValue={(selected) =>
                          selected.map((item) => item.label).join(", ")
                        } // Display only names
                        MenuProps={MenuProps}
                      >
                        {allClient?.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            <Checkbox
                              checked={
                                personName.findIndex(
                                  (selectedItem) =>
                                    selectedItem.label === item.label
                                ) > -1
                              }
                            />
                            <ListItemText primary={item.label} />
                          </MenuItem>
                        ))}
                      </MultiSelect>
                    </div>
                    {errorvalidation.workerClientsIds && (
                      <div className="text-red-500 text-sm mt-1 ">
                        {errorvalidation.workerClientsIds}
                      </div>
                    )}
                  </div>
                </div>
              </ScrollBar>
            </div>
          </div>
        )}
        {stepForm == 1 && !(personName?.length > 0 && personName[0]?.is_client_pays === true) && (
          <Elements stripe={stripePromise}>
            <PaymentMethodForCsv
              personName={personName}
              newSeat={finalCsvData.length - seatCount}
              provider_type_id={provider_type_id}
              openUnsaveDialog={onCloseNextCsv}
              updateObject={{
                worker_invite_data: finalCsvData,
                trading_name:
                  SpecificProviderData?.trading_name /* provider trading name */,
                provider_org_id: orgId,
                provider_fa_id: SpecificProviderData?.provider_fa_id,
                current_user: current_user,
                clientOrgIds: addWorkerData.workerClientsIds,
                client_trading_names: personName?.length > 0 ? personName.map(client => client?.label) : [],

              }}
              subscriptionStatus={subscriptionStatus}
            />
          </Elements>
        )}

        {stepForm != 1 && (
          <div className="flex dailog-footer">
            <BtnLight
              className="mr-1.5 px-4"
              variant="plain"
              onClick={onCloseNextCsv}
            >
              Cancel
            </BtnLight>
            <BtnPrimary
              disabled={!(addWorkerData.workerClientsIds.length > 0)}
              onClick={() =>
                submitCsvData(
                  stepForm == 1 ? "payment" : 0,
                  (finalCsvData.length) <= seatCount
                )
              }
              className="ml-1.5"
            >
              {(finalCsvData.length) <= seatCount ? "Invite" : "Next"}
            </BtnPrimary>
          </div>
        )}
      </Dialog>

      {/* Succesfull Dilog Box */}
      <Dialog
        isOpen={dialogAddOpen}
        onClose={onAddDialogClose}
        onRequestClose={onAddDialogClose}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              width="22"
              height="23"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m8.75 11.727 8.75-8.75M8.856 12l2.19 5.632c.193.496.29.744.428.816.12.063.264.063.385 0 .14-.072.236-.32.43-.816L17.78 3.56c.175-.447.262-.671.215-.814a.417.417 0 0 0-.264-.263c-.143-.048-.366.04-.814.214L2.844 8.188c-.496.193-.744.29-.816.43a.417.417 0 0 0 0 .384c.072.139.32.235.817.428l5.631 2.19c.1.04.151.06.194.09.037.026.07.06.097.097.03.042.05.092.089.193z"
                stroke="#000"
                strokeWidth="1.667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
            Invitation sent successfully
          </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnPrimary onClick={onAddDialogClose}>Close</BtnPrimary>
        </div>
      </Dialog>
    </React.Fragment>
  );
};
export default Workers;
